// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3xuWC","additionalInfo":"AgreementModal_additionalInfo__31W9V"};